import React from 'react'

const CategoryMarker = React.memo(
  function CategoryMarker(props) {
    return(
      <div 
        className='category-marker'
        style={{bottom: `${props.position}px` }}
      >
        <i className='fa fa-caret-right'/>
      </div>
    )
  }
)

export default CategoryMarker;